import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ExcelJS from "exceljs";
import formatDate from "../functions/formatDate";


export const exportToExcel = async (jsonData, filename = "report.xlsx") => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("report");

    // 💡 Устанавливаем стили для заголовков
    const headerStyle = {
        font: { bold: true, size: 10 }, // ✅ Уменьшаем шрифт
        alignment: { vertical: "middle", horizontal: "center", wrapText: true },
        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "CCCCCC" } }
    };

    // 📌 Добавляем заголовки
    sheet.columns = [
        { header: "№", key: "number", width: 5 },
        { header: "Виды работ", key: "name", width: 70 },
        { header: "Ед.изм", key: "unit", width: 12 },
        { header: "Выполнение", key: "complited", width: 12 },
        { header: "Проект", key: "project", width: 12 },
        { header: "Остаток", key: "remain", width: 12 },
        { header: "%", key: "percent", width: 12 },
    ];

    sheet.getRow(1).eachCell(cell => {
        cell.style = headerStyle
    })

    jsonData.map( (item,key) => {
        const row = sheet.addRow({
            number: key+1,
            name: item.name,
            unit: item.unit,
            complited: item.complited,
            project: item.project,
            remain: item.project-item.complited,
            percent: item.project > 0
                ? ((item.complited / item.project) * 100).toFixed(0) + " %"
                : "0 %"
        })
        row.eachCell(cell => {
            cell.style = {
                font: { size: 9 }, // ✅ Уменьшаем шрифт текста в ячейках
                alignment: { vertical: "middle", horizontal: "center", wrapText: true } // ✅ Центрируем содержимое
            }
        })
    })

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), filename);
};